import React from "react";

import styles from "./Footer.module.css";

import IFooterProps from "./dto/IFooterProps";
import FooterState from "./dto/FooterState";

export default class Footer extends React.Component<IFooterProps, FooterState> {
  constructor(props: IFooterProps) {
    super(props);
    this.state = new FooterState();
  }

  public render() {
    return (
      <footer className={styles.footer}>
        <div className={styles.footerContent}>
          <div className={styles.infoContainer}>
            <div className={styles.infoContainerPart}>
              <div className={styles.infoContainerHeader}>
                NAVIGATION
              </div>
              <div className={styles.infoContainerText}>
                <a href="https://www.kern-unternehmensnachfolge.com/datenschutz/" target="_blank" rel="noreferrer">Datenschutz</a>
                <a href="https://www.kern-unternehmensnachfolge.com/impressum/" target="_blank" rel="noreferrer">Impressum</a>
              </div>
            </div>
            <div className={styles.infoContainerPart}>
              <div className={styles.infoContainerHeader}>
                KERN - Zukunft für Lebenswerke
              </div>
              <div className={styles.infoContainerText}>
                Ihre Spezialisten für Unternehmensnachfolge, Generationswechsel, Unternehmensverkauf und Unternehmenskauf
              </div>
            </div>
          </div>
          {this.renderCopyRight()}
        </div>
      </footer>
    );
  }

  private renderCopyRight = (): JSX.Element => {
    let year = new Date().getFullYear();
    return (
      <div className={styles.copyRightContainer}>
        &copy; {year} KERN
      </div>
    );
  }
}